import { map, Observable } from 'rxjs';
import {
  AuthService,
  IMPERSONATION_SESSION_STORAGE_KEY,
} from '@nimmsta/ng-commons-lib/auth';
import { IconAction } from '@nimmsta/ng-commons-lib/data-table';
import { User, UserStatus } from '@nimmsta/ng-commons-lib/models';

export class ImpersonateAction extends IconAction<User> {
  constructor(
    _text: string,
    private authService: AuthService,
    _secondaryIcon?: string,
  ) {
    super(_text, 'swap_horiz', false, undefined, _secondaryIcon);
  }

  override isEnabled(user: User): Observable<boolean> {
    return this.authService.getCurrentUser().pipe(map(
      (currentUser) => currentUser.email !== user.email
        && user.status === UserStatus.ACTIVE // only allow active users to be impersonated
        && sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY) === null,
    ));
  }
}
